<template>
    <div
        v-cloak
        class="row"
    >
        <div class="col-xs-12">
            <div class="box box-primary">
                <div class="box-header with-border">
                    <h3 class="box-title">API Providers Table</h3>
                    <div class="box-tools pull-right">
                        <button
                            class="btn btn-box-tool"
                            title="Collapse"
                            type="button"
                            @click="toggleCollapse"
                        >
                            <i
                                :class="changeIcon(collapse)"
                                class="fa"
                            ></i>
                        </button>
                    </div>
                </div>
                <div
                    v-if="providers.total"
                    class="box-body with-border clearfix"
                    @click="preventEnter"
                    @keydown="preventEnter"
                >
                    <BadgeTotal
                        :value="providers.total"
                        color="gray"
                        :label="`${$t('total')}: `"
                    />

                    <pagination
                        :class="isDisabled()"
                        :data="providers"
                        :limit="$root.paginator.settings.limit"
                        :size="$root.paginator.settings.size"
                        class="pull-right no-margin vue-pagination"
                        show-disabled
                        @pagination-change-page="getData"
                    >
                        <span slot="prev-nav">
                            <i class="fa fa-angle-double-left"></i>
                        </span>
                        <span slot="next-nav">
                            <i class="fa fa-angle-double-right"></i>
                        </span>
                    </pagination>
                </div>
                <vue-slide-up-down
                    :active="collapse"
                    :duration="durationCollapse"
                >
                    <div
                        v-if="!providers"
                        class="box-body"
                    >
                        <p>There are no API Providers in the system.</p>
                    </div>
                    <div v-else>
                        <div class="box-body table-responsive no-padding">
                            <table class="table table-striped table-hover">
                                <tbody>
                                    <tr>
                                        <th>ID</th>
                                        <th>Name</th>
                                        <th>Type</th>
                                        <th class="text-center">Use Numbers</th>
                                        <th class="text-center">Use Surcharge Fee</th>
                                        <th class="text-center">Active</th>
                                        <th class="text-center">Apis</th>
                                        <th class="text-center">Short Codes</th>
                                        <th class="text-center">Use TFN</th>
                                        <th class="text-center">Use Setting Plus</th>
                                        <th class="text-center">PBody Categories</th>
                                        <th class="text-center">Badwords</th>
                                        <th class="text-right">Created At</th>
                                        <th class="text-right">Updated At</th>
                                        <th></th>
                                    </tr>
                                    <tr
                                        v-for="provider in providers.data"
                                        :key="provider.id"
                                    >
                                        <td>{{ provider.id }}</td>
                                        <td>{{ provider.name }}</td>
                                        <td>
                                            {{ campaignTypes[provider.campaign_type_id] }}
                                        </td>
                                        <td class="text-center">
                                            <ValueYesNo :value="provider.use_numbers" />
                                        </td>
                                        <td class="text-center">
                                            <ValueYesNone :value="provider.use_surcharge_fee" />
                                        </td>
                                        <td class="text-center">
                                            <ValueYesNo :value="provider.active" />
                                        </td>
                                        <td class="text-center">
                                            <EmptyBadge
                                                :value="provider.apis_count"
                                                color="gray"
                                            />
                                        </td>
                                        <td class="text-center">
                                            <ValueYesNo :value="provider.sc" />
                                        </td>
                                        <td class="text-center">
                                            <ValueYesNo :value="provider.use_tfn" />
                                        </td>
                                        <td class="text-center">
                                            <ValueYesNo :value="provider.use_setting_plus" />
                                        </td>
                                        <td class="text-center">
                                            <EmptyBadge
                                                :value="provider.p_body_categories_count"
                                                color="gray"
                                            />
                                        </td>
                                        <td class="text-center">
                                            <EmptyBadge
                                                :value="provider.badwords_count"
                                                color="gray"
                                            />
                                        </td>
                                        <td class="text-right">
                                            {{ provider.created_at }}
                                        </td>
                                        <td class="text-right">
                                            {{ provider.updated_at }}
                                        </td>
                                        <td class="text-right">
                                            <template v-if="availableToActivate">
                                                <a
                                                    v-if="provider.active"
                                                    :href="getRoute(provider.id, 'deactivate')"
                                                    class="btn btn-sm btn-danger"
                                                >
                                                    <i class="fa fa-ban"></i>
                                                    <span class="sr-only">Deactivate</span>
                                                </a>
                                                <a
                                                    v-else
                                                    :href="getRoute(provider.id, 'activate')"
                                                    class="btn btn-sm btn-success"
                                                >
                                                    <i class="fa fa-check"></i>
                                                    <span class="sr-only">Activate</span>
                                                </a>
                                            </template>
                                            <a
                                                :href="getRoute(provider.id, 'export')"
                                                class="btn btn-sm btn-warning"
                                            >
                                                <i class="fa fa-download"></i>
                                                <span class="sr-only">Export DID Statistic</span>
                                            </a>
                                            <a
                                                :href="getRoute(provider.id, 'exportLastWeek')"
                                                class="btn btn-sm btn-warning"
                                            >
                                                <i class="fa fa-download"></i>
                                                <span class="sr-only">Export DID Statistic for last week</span>
                                            </a>
                                            <a
                                                :href="getRoute(provider.id, 'edit')"
                                                class="btn btn-sm btn-primary"
                                            >
                                                <i class="fa fa-edit"></i>
                                                <span class="sr-only">Edit</span>
                                            </a>
                                            <a
                                                :href="getRoute(provider.id, 'show')"
                                                class="btn btn-sm btn-info"
                                            >
                                                <i class="fa fa-eye"></i>
                                                <span class="sr-only">Show</span>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div
                            class="box-footer clearfix"
                            @click="preventEnter"
                            @keydown="preventEnter"
                        >
                            <pagination
                                :class="isDisabled()"
                                :data="providers"
                                :limit="$root.paginator.settings.limit"
                                :size="$root.paginator.settings.size"
                                class="pull-right no-margin vue-pagination"
                                show-disabled
                                @pagination-change-page="getData"
                            >
                                <span slot="prev-nav">
                                    <i class="fa fa-angle-double-left"></i>
                                </span>
                                <span slot="next-nav">
                                    <i class="fa fa-angle-double-right"></i>
                                </span>
                            </pagination>
                        </div>
                    </div>
                </vue-slide-up-down>
                <!-- /.box-body -->
            </div>
        </div>
    </div>
</template>

<script>
import ValueYesNo from '../../subcomponents/ValueYesNo';
import ValueYesNone from '../../subcomponents/YesOrNone';
import EmptyBadge from '../../subcomponents/EmptyBadge';
import BadgeTotal from '../../subcomponents/BadgeTotal';

export default {
    components: {
        ValueYesNo,
        ValueYesNone,
        EmptyBadge,
        BadgeTotal,
    },
    data() {
        return {
            availableToActivate: false,
            providers: {},
            campaignTypes: {},
            pageNumber: this.$route.query.page,
            route: {
                export: '/apis/providers/export-did-stats/:id:',
                exportLastWeek: '/apis/providers/export-did-stats/:id:?last_week=1',
                edit: '/apis/providers/:id:/edit',
                show: '/apis/providers/:id:',
                activate: '/apis/providers/:id:/activate',
                deactivate: '/apis/providers/:id:/deactivate',
            },
            disablePagination: true,
            collapse: true,
            durationCollapse: 700,
        };
    },
    mounted() {
        this.checkPermissions().then(() => {
            this.getData(this.pageNumber);
        })
    },
    methods: {
        checkPermissions() {
            return axios.get('/profile/auth-info').then(({data}) => {
                for (let role of data.user.roles) {
                    if (role.name === 'SUPERADMIN' || role.name === 'ADMIN') {
                        this.availableToActivate = true;
                    }
                }
            });
        },
        preventEnter: function (event) {
            if (this.disablePagination) {
                return event.preventDefault();
            }
        },
        getData(page = 1) {
            this.disablePagination = true;

            axios.get('/apis/providers/data?page=' + page).then((response) => {
                if (String(page) !== String(this.$route.query.page)) {
                    this.$router.push({
                        query: Object.assign({}, this.$route.query, {
                            page: String(page),
                        }),
                    });
                }

                if (page > response.data.providers.last_page) {
                    return this.getData();
                }

                this.providers = response.data.providers;
                this.campaignTypes = response.data.campaignTypes;
                this.disablePagination = false;
            });
        },
        getRoute: function (id, type) {
            return this.route[type].replace(':id:', id);
        },
        isDisabled: function () {
            return this.disablePagination ? 'disabled-box' : '';
        },
        changeIcon: function (value) {
            return value ? 'fa-minus' : 'fa-plus';
        },
        toggleCollapse() {
            this.collapse = !this.collapse;
        },
    },
};
</script>
